import { resolveInputFontSize } from '../TextInputStyles';
/**
 * Used to display a ReactNode in the adornment slot
 */
export const styledNodeAdornment = _ref => {
  let {
    theme,
    size,
    disabled
  } = _ref;
  return {
    display: 'flex',
    justifyContent: 'center',
    svg: {
      fontSize: resolveInputFontSize(theme, size),
      color: disabled ? theme.tokens.ComponentTextInputDisabledColor : theme.tokens.ComponentTextInputAdornmentIconColor
    }
  };
};